import React, { useEffect, useRef, useState } from 'react';
import styles from './VideoSpeedMenu.module.scss';
import Menu from '../Menu/Menu';
import MenuItem from '../Menu/MenuItem';
import Icon from '../Icon/Icon';
import useOutsideClick from '../../hooks/useOutsideClick';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const initSpeedMenu = {
  show: false,
  x: 0,
  y: 0,
};

const availableSpeedLevels = [0.8, 1, 1.2, 1.5, 1.7, 2, 2.5];

const VideoSpeedMenu = ({ playerNode, playbackRate, handleChangePlaybackRate, isMobileView, hideControls }) => {
  const [speedMenu, setSpeedMenu] = useState(initSpeedMenu);
  const [menuStyles, setMenuStyles] = useState({ top: 0, left: 0, opacity: 0 });
  const menuRef = useRef(null);

  const { t } = useTranslation();

  useOutsideClick(menuRef, () => {
    if (speedMenu.show) {
      setSpeedMenu(initSpeedMenu);
    }
  });

  const handleSpeedChange = value => {
    setSpeedMenu(initSpeedMenu);
    handleChangePlaybackRate(value);
  };

  const handleOpenMenu = e => {
    setSpeedMenu({ show: true, x: e.clientX, y: e.clientY - 40 });
  };

  useEffect(() => {
    if (hideControls) {
      setSpeedMenu(initSpeedMenu);
    }
  }, [hideControls]);

  useEffect(() => {
    if (menuRef.current) {
      let top = speedMenu.y;
      let left = speedMenu.x;

      if (isMobileView) {
        left = playerNode?.offsetWidth + menuRef.current.offsetWidth / 2;
        if (menuRef.current.offsetHeight > playerNode?.offsetHeight) {
          top += playerNode?.offsetHeight;
        }
      } else {
        left += 80;
      }
      setMenuStyles({ top, left, opacity: 1 });
    }
  }, [speedMenu]);

  return (
    <>
      <div className={styles.currentSpeed} onClick={handleOpenMenu}>
        <span tabIndex={0} aria-label={t('my_video.tools.speed.title')}>{playbackRate}x</span>
      </div>
      {speedMenu.show && (
        <Menu ref={menuRef} className={styles.videoSpeedMenu} customStyles={menuStyles}>
          {availableSpeedLevels.map(speedLevel => (
            <MenuItem onClick={() => handleSpeedChange(speedLevel)} key={speedLevel} className={styles.item}>
              {playbackRate === speedLevel && <Icon src="check" className={styles.checkIcon} />}
              <span className={cx({ [styles.notChecked]: playbackRate !== speedLevel })}>{speedLevel}x</span>
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default VideoSpeedMenu;
